import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const ManipulationArray = () => {
  function calcHeight(nbLine){
    let calc = 19*nbLine
    return calc+"px"
    }

  return (

    <div id="articleContent" className="ManipulationArray">
      <table class="propsJavascript">
        <tr>
          <td colspan="3">La taille d'un tableau</td>
        </tr>
        <tr>
          <td>.length</td>
          <td>

<pre>
        <code>
          <AceEditor
            height={calcHeight(9)}
            width="582px"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var jours = new Array("Lundi","Mardi","Mercredi")
console.log(jours.length)
// Expected output : 3
jours[jours.length] = "Ajout"
console.log(jours)
// Expected output : ["Lundi","Mardi","Mercredi","Ajout"]
jours[jours.length] = "
console.log(jours)
// Expected output : ["Lundi","Mardi","Mercredi","Ajout","]`}
          />
        </code>
      </pre>
          </td>
          <td>Permet de récupérer la taille d'un tableau. Cela permet aussi d'ajouter un élement à
la fin du tableau.</td>
        </tr>


        <tr>
    <td colspan="3">Les tableaux au format JSON</td>
</tr>

<tr>

    <td>JSON</td>

    <td>


    <pre>
      <code>
      <AceEditor
      height={calcHeight(5)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter= {true}
      mode="javascript"
      theme="monokai"
      value={`var jours = []
console.log(jours)
// Expected output : []
// Expected output : ["Lundi","Mardi","Mercredi","Ajout","]`}
        />
      </code>
      </pre>

    </td>

    <td>Utilisé fréquement</td>

</tr>


<tr>
    <td colspan="3">Convertir un tableau en chaînes de caractères</td>
</tr>

<tr>

    <td>.toString()</td>

    <td>

    <pre>
        <code>
          <AceEditor
            height={calcHeight(4)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var jours = ["Lundi","Mardi","Mercredi"]
            console.log(jours.toString())
            // Expected output : Lundi,Mardi,Mercredi`}
          />
        </code>
      </pre>


    </td>

    <td>Convertit en chaîne de caractères faciles à lire sur une seule ligne</td>

</tr>

<tr>

    <td>.join()</td>

    <td>

    <pre>
        <code>
          <AceEditor
            height={calcHeight(4)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var jours = ["Lundi","Mardi","Mercredi"]
            console.log(jours.join(" ... "))
            // Expected output : Lundi,Mardi,Mercredi`}
          />
        </code>
      </pre>

    </td>

    <td>Convertit en chaîne de caractères en permettant l'ajout d'un séparateur</td>

</tr>


<tr>
    <td colspan="3">Vérifier le format d'un tableau</td>
</tr>

<tr>

    <td>typeOf(), Array.isArray()</td>

    <td>

    <pre>
        <code>
          <AceEditor
            height={calcHeight(8)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var jours = ["Lundi","Mardi","Mercredi"]
            console.log(typeof(jours))
            console.log(Array.isArray(jours))
            console.log(Array.isArray(8))
            // Expected output : object
            // Expected output : true
            // Expected output : false`}
          />
        </code>
      </pre>


    </td>

    <td>TypeOf retourne le type de l'élement et .array si c'est un tableau ou non</td>

</tr>




<tr>
    <td colspan="3">La copie de tableau</td>
</tr>

<tr>

    <td>Spread operator</td>

    <td>

    <pre>
        <code>
          <AceEditor
            height={calcHeight(10)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var jours = ["Lundi","Mardi","Mercredi"]
            console.log(jours)
            var jours2 = [...jours]
            jours2.pop()
            console.log(jours2)
            console.log(jours)
            // Expected output : ['Lundi', 'Mardi', 'Mercredi']
            // Expected output : ['Lundi', 'Mardi']
            // Expected output : ['Lundi', 'Mardi', 'Mercredi']`}
          />
        </code>
      </pre>
    </td>

    <td>Impossible de dupliquer le contenu d'un tableau de manière classique</td>

</tr>



<tr>

    <td>Boucle</td>

    <td>


    <pre>
        <code>
          <AceEditor
            height={calcHeight(11)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var jours = ["Lundi","Mardi","Mercredi"]
            var days = []
            for (var i=0;i<jours.length;i++){
                days[i] = jours[i]
            }
            days[0] = "Bla"
            console.log(jours)
            console.log(days)
            // Expected output : ['Lundi', 'Mardi', 'Mercredi']
            // Expected output : [ 'Bla', 'Mardi', 'Mercredi' ]`}
          />
        </code>
      </pre>

    </td>

    <td>Impossible de dupliquer le contenu d'un tableau de manière classique</td>

</tr>



<tr>
    <td colspan="3">Les tableaux spéciaux</td>
</tr>

<tr>

    <td>Tableau associatifs</td>

    <td>

    <pre>
        <code>
          <AceEditor
            height={calcHeight(9)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var monnaies = []
            monnaies["EUR"] = "Euro"
            monnaies["USD"] = "Dollar américain"
            monnaies["BTC"] = "Bitcoin"
            console.log(monnaies)
            console.log(monnaies.length)
            // Expected output : [ EUR: 'Euro', USD: 'Dollar américain', BTC: 'Bitcoin' ]
            // Expected output : 0 (pas d'indice auto-incrémenté)`}
          />
        </code>
      </pre>

    </td>

    <td>L'adressage des élements d'un tableau n'est pas nécessairement un indice ordonnée
commençant par 0. Il est
possible de définir des indices sous forme de nombres ou de chaînes de caractères.
    </td>

</tr>



<tr>

    <td>Parcours d'un tableau associatif</td>

    <td>


    <pre>
        <code>
          <AceEditor
            height={calcHeight(8)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`for(var code in monnaies){
              console.log(code+ " : " + monnaies[code])
          }
          // Expected output : 
          // EUR : Euro
          // USD : Dollar américain
          // BTC : Bitcoin`}
          />
        </code>
      </pre>
    </td>

    <td> </td>

</tr>


<tr>

    <td>Vérifier l'existence d'un élement dans un tableau associatif</td>

    <td>

      
    <pre>
        <code>
          <AceEditor
            height={calcHeight(6)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`if (typeof monnaies["YEN"] !== "undefined"){
              console.log("Le YEN n'est pas présent dans le tableau")
          }else{
              console.log("Le YEN n'est pas présent dans le tableau") 
          }`}
          />
        </code>
      </pre>


    </td>

    <td> </td>

</tr>

<tr>
    <td> Les tableaux mutlidimensionnels </td>
    <td>


    <pre>
        <code>
          <AceEditor
            height={calcHeight(10)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var clients=[]
            clients['Pierre']=[24,5,807.5]
            clients['Paul']=[4,54,707]
            clients['Jacques']=[8,7,100]
            console.log(clients)
            // Expected output :
            // [ Pierre: [ 24, 5, 807.5 ],
            // Paul: [ 4, 54, 707 ],
            // Jacques: [ 8, 7, 100 ] ]`}
          />
        </code>
      </pre>
    </td>
    <td> Exemple de tableau à deux dimenssion. Dans cet exemple les index sont Pierre, Paul
et Jacques </td>
</tr>
<tr>
    <td> Les tableaux d'objets </td>
    <td>


    <pre>
        <code>
          <AceEditor
            height={calcHeight(11)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var clients = [
              {nom:'Pierre',age:'29',nb:5,ca:807.50},
              {nom:'Paul',age:'34',nb:5,ca:100.50},
              {nom:'Jacques',age:'50',nb:5,ca:200.50}
          ]
          console.log(clients)
          // Expected output :
          // [ { nom: 'Pierre', age: '29', nb: 5, ca: 807.5 },
          //   { nom: 'Paul', age: '34', nb: 5, ca: 100.5 },
          //   { nom: 'Jacques', age: '50', nb: 5, ca: 200.5 } ]`}
          />
        </code>
      </pre>
    </td>
    <td> Ici les index sont 0,1,2 et le nom des entêtes de colonne Nom, Age, Nb et Ca </td>
</tr>
      </table>

      <h2>Les méthodes de l'objet Array</h2>


      <table class='propsJavascript'>
    <tr>
<td> .concat() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(14)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`const jours1 = ['Lundi', 'Mardi', 'Mercredi'];
const jours2 = ['Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
const jours3 =['Bla']
const semaine = jours1.concat(jours2).concat(jours3);
console.log(semaine);
// expected output: 
//[ 'Lundi',
//  'Mardi',
//  'Mercredi',
//  'Jeudi',
//  'Vendredi',
//  'Samedi',
//  'Dimanche',
//  'bljazbljabz' ]`}
          />
        </code>
      </pre>
</td>
<td> Retourne un nouveau tableau, constitué de la fusion entre le tableau sur lequel elle
    s'applique et les tableaux passés en paramètres. </td>
    </tr>
    <tr>
<td> .every() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(8)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var number = (currentValue) => currentValue < 40;
var tableau = [1, 30, 39, 29, 10, 1,10];
console.log(tableau.every(number));
// expected output: true
var jours = (currentValue) => currentValue === "Lundi";
var tableau = ["Lundi","Mardi","Mercredi"];
console.log(tableau.every(jours));
// expected output: false (impossible à utiliser avec les string)`}
          />
        </code>
      </pre>
</td>
<td> Teste si l'ensemble des élements du tableau sur lequel elle s'applique vérifie la
    condition testée par la fonction passés en argument. </td>
    </tr>
    <tr>
<td> .filter() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(5)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var filtrage = (currentValue) => currentValue%2 === 0;
var tableau = [1, 30, 39, 29, 10, 1,10];
console.log(tableau.filter(filtrage));
// expected output: [ 30, 10, 10 ]
// Retourne les élement pairs`}
          />
        </code>
      </pre>
</td>
<td> Retourne un nouveau tableau contenant tous les élements du tableau initial qui
    remplissent la condition définie dans la fonction passée en paramètre </td>
    </tr>
    <tr>
<td> .flat(profondeur) </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(6)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = [30,[10,11,12],[["Lundi","888"],["Mercredi","Jeudi"],5]];
console.log(tableau)
console.log(tableau.flat(3))
// expected output: [30, Array(3), Array(3)]
// expected output: [30, 10, 11, 12, "Lundi", "888", "Mercredi", "Jeudi", 5]`}
          />
        </code>
      </pre>
</td>
<td> Retourne un tableau multidimensionnel aplati </td>
    </tr>
    <tr>
<td> .forEach() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(6)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = ["Lundi","Mardi"]
var increment = 1
tableau.forEach(element => console.log(element+" "+ increment++ ));
// expected output: 
// Lundi 1
// Mardi 2`}
          />
        </code>
      </pre>
</td>
<td> Parcours un à un les élements du tableau et exécute une fonction sur chaque élement
    trouvé </td>
    </tr>
    <tr>
<td> .includes() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height="100px"
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = ["Lundi","Mardi","Mercredi","Jeudi",1]
console.log(tableau.includes("Lundi"))
console.log(tableau.includes("Bla"))
// expected output: true
// expected output: false`}
          />
        </code>
      </pre>
</td>
<td> Retourne true si le paramètre est présent dans le tableau </td>
    </tr>
    <tr>
<td> .indexOf() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(3)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = ["Lundi","Mercredi",1,"Lundi","Mercredi"]
console.log(tableau.indexOf('Mercredi'));
// expected output: 1`}
          />
        </code>
      </pre>
</td>
<td> Renvoie l'indice du premier élement trouvé après un indice de départ. Si aucun élement
    ne correspond, la méthode renvoie -1 </td>
    </tr>
    <tr>
<td> .lastIndexOf() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(3)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`"var tableau = ["Lundi","Mercredi",1,"Lundi","Mercredi"]
console.log(tableau.lastIndexOf('Mercredi'));
// expected output: 4`}
          />
        </code>
      </pre>
</td>
<td> Retourne l'indice du dernier élement trouvé et -1 si l'élément n'est pas trouvé </td>
    </tr>
    <tr>
<td> .join() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(3)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`"var tableau = ["Lundi","Mercredi",1,"Lundi","Mercredi"]
console.log(tableau.join());
// expected output: Lundi,Mercredi,1,Lundi,Mercredi"`}
          />
        </code>
      </pre>
</td>
<td> Retourne une chaîne de caractères composée des élements du tableau rassemblés par un
    séparateur passé en paramètre. </td>
    </tr>
    <tr>
<td> .map() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(4)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = [1, 4, 9, 16];
var tableau2 = tableau.map(x => x * 2);
console.log(tableau2);
// expected output: Array [2, 8, 18, 32]`}
          />
        </code>
      </pre>
</td>
<td> Retourne un nouveau tableau composé des élements du tableau initial auxquels une
    fonction est appliquée. </td>
    </tr>
    <tr>
<td> .pop() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(5)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = ["Lundi","Mardi","Mercredi","Jeudi"]
console.log(tableau.pop())
console.log(tableau)
// expected output: Jeudi
// expected output: [ 'Lundi', 'Mardi', 'Mercredi' ]`}
          />
        </code>
      </pre>
</td>
<td> Supprime le dernier élement d'un tableau. Elle retourne l'élément supprimé et elle
    modifie directement le tableau initial. </td>
    </tr>
    <tr>
<td> .push() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(5)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = ["Lundi","Mardi","Mercredi","Jeudi"]
console.log(tableau.push("bla"))
console.log(tableau)
// expected output: 5
// expected output: [ 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'bla' ]`}
          />
        </code>
      </pre>
</td>
<td> Ajoute les paramètres passés dans le tableau sur lequel elle s'applique. Elle retourne
    la nouvelle taille du tableau complété. </td>
    </tr>
    <tr>
<td> .reduce() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(8)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = [1, 2, 3, 4];
var reducer = (accumulator, currentValue) => accumulator + currentValue;
console.log(tableau.reduce(reducer));
// expected output: 10
console.log(tableau.reduce(reducer, 5));
// 5 + 1 + 2 + 3 + 4
// expected output: 15`}
          />
        </code>
      </pre>
</td>
<td> Réduit le tableau en appliquant une fonction accumulatrice sur deux élements pour n'en
    retourner qu'un seul (reduceRight, idem mais inversé) </td>
    </tr>
    <tr>
<td> .reverse() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(3)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = ["Lundi","Mardi","Mercredi","Jeudi"]
console.log(tableau.reverse())
// expected output: [ 'Jeudi', 'Mercredi', 'Mardi', 'Lundi' ]`}
          />
        </code>
      </pre>
</td>
<td> Inverse l'ordre des éléments du tableau initial </td>
    </tr>
    <tr>
<td> .shift() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(4)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = ["Lundi","Mardi","Mercredi","Jeudi"]
console.log(tableau.shift())
console.log(tableau)
// expected output: Lundi`}
          />
        </code>
      </pre>
</td>
<td> Proche de pop() , supprime le premier élément du tableau initial. </td>
    </tr>
    <tr>
<td> .slice() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(7)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`const animals = ['ant', 'bison', 'camel', 'duck', 'elephant'];
console.log(animals.slice(2));
// expected output: Array ["camel", "duck", "elephant"]
console.log(animals.slice(2, 4));
// expected output: Array ["camel", "duck"]
console.log(animals.slice(1, 5));
// expected output: Array ["bison", "camel", "duck", "elephant"]`}
          />
        </code>
      </pre>
</td>
<td> Retourne un nouveau tableau composé de l'extrait du tableau initial entre l'indice de
    début inclus et l'indice de fin exclu. </td>
    </tr>
    <tr>
<td> .some() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(4)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = [1, 2, 3, 4, 5];
const even = (element) => element % 2 === 0;
console.log(tableau.some(even));
// expected output: true`}
          />
        </code>
      </pre>
</td>
<td> Comme every() sauf qu'il suffit qu'un seul élément corresponde à la fonction de test
    passée en paramètre </td>
    </tr>
    <tr>
<td> .sort() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(8)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = ['March', 'Jan', 'Feb', 'Dec'];
tableau.sort();
console.log(tableau);
// expected output: Array ["Dec", "Feb", "Jan", "March"]
var tableau = [1, 30, 4, 21, 100000];
tableau.sort();
console.log(tableau);
// expected output: Array [1, 100000, 21, 30, 4]`}
          />
        </code>
      </pre>
</td>
<td> Trie le tableau par ordre croissant ou par ordre alphabétique </td>
    </tr>
    <tr>
<td> .splice() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(7)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = ['ant', 'bison', 'camel', 'duck', 'elephant'];
console.log(tableau.splice(2));
// expected output: Array ["camel", "duck", "elephant"]
console.log(tableau.splice(2, 4));
// expected output: Array []
console.log(tableau.splice(1, 5));
// expected output: Array ["bison"]`}
          />
        </code>
      </pre>
</td>
<td> Ecrase une tranche du tableau défini par l'indice de début inclus et un nombre
    d'éléments. </td>
    </tr>
    <tr>
<td> .unshift() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(5)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var tableau = [1, 2, 3];
console.log(tableau.unshift(4, 5));
// expected output: 5
console.log(tableau);
// expected output: Array [4, 5, 1, 2, 3]`}
          />
        </code>
      </pre>
</td>
<td> Insère des éléments au début du tableau </td>
    </tr>
</table>

<h2>Les fonctionnalités manquantes</h2>

<table class='propsJavascript'>

    <tr>
<td> shuffle() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(9)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`function shuffle(tab) {
tab.sort(function(a,b) {
  return Math.random()-Math.random();
});
      }
      var tableau = ["Lundi","Mardi","Mercredi","Jeudi"]
      shuffle(tableau);
      console.log(tableau.toString());
      // Expected output : Mercredi,Mardi,Lundi,Jeudi"`}
          />
        </code>
      </pre>
</td>
<td> Mélanger un tableau </td>
    </tr>
    <tr>
<td> arrayRand() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(25)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`function shuffle(tab) {
tab.sort(function(a,b) {
  return Math.random()-Math.random();
});
      }
      function arrayRand(tableau, nb=1) {
/* Création du tableau temporaire de travail */
var tmp=[];
tableau.forEach(function(e) {
  tmp.push(e);
});
/* Mélange */
shuffle(tmp);
/* Retour du 1er élément ou d'une tranche */
if (nb==1) { 
 return tmp[0];      
} else {
  return tmp.slice(0, nb);
}
      }
      var mois=["Jan","Fév","Mar","Avr","Mai"];
      console.log(arrayRand(mois));
      console.log(arrayRand(mois,3).toString());
    // Expected output : Avr
    // Expected output : Jan,Fév,Mar`}
          />
        </code>
      </pre>
</td>
<td> Extraire des éléments au hasard </td>
    </tr>
    <tr>
<td> arrayUnique() </td>
<td>
   <pre>
        <code>
          <AceEditor
            height={calcHeight(12)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`function arrayUnique(tableau) {
var tmp=[];
tableau.forEach(function(e) {
  if (tmp.indexOf(e)==-1) { /* Si e n'est pas dans tmp */
    tmp.push(e);
  }
});
return tmp;
      }
      var doublons=["Jean", "Gérard", "Pierre", "Paul"];
      console.log(doublons.toString());
      console.log(arrayUnique(doublons).toString());`}
          />
        </code>
      </pre>
</td>
<td> Dédoublonner un tableau </td>
    </tr>
</table>



<h2>Les ensembles SET</h2>
<p>Le constructeur Set() définit un ensemble d'éléments uniques interdisant tout doublon.</p>
<pre>
        <code>
          <AceEditor
            height={calcHeight(40)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var bee=new Set(['noire', 'buckfast', 'caucasica']);
console.log(bee);
console.log(bee.size);
console.log(bee.has('buckfast'));
console.log(bee.has('carnica'));
bee.add('carnica').add('ligustica').add('buckfast');
console.log(bee.size);
bee.delete('buckfast');
console.log(bee);
bee.clear();
console.log(bee.size);       
var bee=new Set(['noire', 'buckfast', 'caucasica']);
console.group('Boucle for of');
var i=0;
for (var element of bee) {
  i++;
  console.log('Element '+i+' '+element);
}
console.groupEnd();      
console.group('Boucle forEach()');
bee.forEach(function(element) {
  console.log(element);    
});
console.groupEnd();
// expected output:  Set(3) {"noire", "buckfast", "caucasica"}
// expected output:  3
// expected output:  expected output:  true
// expected output:  false
// expected output:  5
// expected output:  Set(4) {"noire", "caucasica", "carnica", "ligustica"}
// expected output:  0
// expected output:  Boucle for of
// expected output:  Element 1 noire
// expected output:  Element 2 buckfast
// expected output:  Element 3 caucasica
// expected output:  Boucle forEach()
// expected output:  noire
// expected output:  buckfast
// expected output:  caucasica
     `}
          />
        </code>
      </pre>


<h2>Conversion Array et Set</h2>
<p>La convertion d'un tableau vers un ensemble est triviale, puisqu'un tableau est attendu en
    paramètre du constructeur Set()</p>
    <pre>
        <code>
          <AceEditor
            height={calcHeight(15)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var bee =new Set(["noire", "buckfast", "caucasica"]);
var bees=Array.from(bee);
console.log(bee);  // Set(3) {"noire", "buckfast", "caucasica"}
console.log(bees); // (3) ["noire", "buckfast", "caucasica"]
/* Retourne un tableau dédoublonné depuis tabOrigine */
function array_unique_set(tabOrigine) {
  let ens=new Set(tabOrigine);
  return Array.from(ens);
}
var tab=new Array(9, 3, 6, "3", 9, 8, 3, 10, 9, "3", "9");
console.log(tab);  
  /* Affiche (11) [9, 3, 6, "3", 9, 8, 3, 10, 9, "3", "9"] */
console.log(array_unique_set(tab));
  /* Affiche (7) [9, 3, 6, "3", 8, 10, "9"] */
    `}
          />
        </code>
      </pre>

<h2>Les méthodes de Map</h2>
<p>Le constructeur Map construit une stucture de données qui associe un clé avec une valeur pour
    former une sorte de cartographie ou de dictionnaire.</p>
    <pre>
        <code>
          <AceEditor
            height={calcHeight(13)}
            width="100%"
            fontSize={16}
            showPrintMargin={false}
            showGutter={false}
            mode="javascript"
            theme="monokai"
            value={`var dic = new Map([ ["acer", "érable"], ["quercus", "chêne"] ]);
    console.log(dic.size); // 3
    console.log(dic);      // Map(2) {"acer" => "érable", "quercus" => "chêne"}
    dic.set("malus", "pommier");
    dic.set("fagus", "hêtre");
    console.log(dic.get("malus"));    // pommier
    console.log(dic.has("populus"));  // false
    console.log(dic.get("populus"));  // undefined
    console.group("dic.forEach()");
    dic.forEach(function(valeur, cle) {
      console.log(cle + " : " + valeur);
    });
    console.groupEnd();`}
          />
        </code>
      </pre>
    </div>
  )
}
